import * as React from "react";
import { useContext } from "react";
import { Dictionary } from "appz";

const ResourceContext = React.createContext<Dictionary<string>>({});

const useResources = (): Dictionary<string> =>
    useContext<Dictionary<string>>(ResourceContext);

export { ResourceContext, useResources };
